import { displayError, getApiUrl, getCurrentLanguageId, addEventListenerIfNotExists } from "./common";
import HttpClient from "./http-client";
import LoadingIndication from "./loading-indication";


export default class SaferPayPayment {
    private baseElement: HTMLElement;
    private buttonElement: HTMLElement;
    private orderGuid: string;

    private static _componentName = 'SaferPayPayment';
    private static buttonName = 'saferpay-proceed-button';

    static get componentName() {
        return SaferPayPayment._componentName;
    }

    constructor() {
        this.baseElement = document.querySelector(`[data-component="${SaferPayPayment.componentName}"]`);
        this.orderGuid = this.baseElement.dataset.orderGuid;
        this.buttonElement = this.baseElement.querySelector(`[data-component-part="${SaferPayPayment.buttonName}"]`);
        addEventListenerIfNotExists(this.buttonElement, 'click', (evt) => this.procceed(evt));
    }

    private async procceed(evt: Event): Promise<void> {
        evt.preventDefault();
        this.startLoading();
        await this.createPayment();

    }

    private async createPayment() {

        const url = `${getApiUrl()}/SaferPayPayment/create-payment`;

        const response = await new HttpClient().fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                orderGuid: this.orderGuid,
                returnUrl: window.location.href,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Current-Language-Id': getCurrentLanguageId()
            }
        }, (e) => {
            this.stopLoading();
            displayError("Payment creation failed. " + e);
            return null;
        });

        if (!response.ok) {
            this.stopLoading();
            displayError("Payment creation failed.");
            return null;
        }

        var json: string = await response.json();
        json = json.replace(/['"]+/g, '');
        window.location.replace(json);

    }

    private startLoading() {
        LoadingIndication.show(this.baseElement);
    }

    private stopLoading() {
        LoadingIndication.hide(this.baseElement);
    }
}
